import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useApiCaller } from '../utils/ApiUtilities';
import { getVerifyEmailUrl } from '../utils/UrlUtilities';
import { constructVerifyEmailPayload } from '../utils/PayloadUtils';

export default function VerifyEmail() {
    const CallApi = useApiCaller();
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const [status, setStatus] = useState('verifying'); // verifying | success | error
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return; // guard React 18 double-invoke; token is single-use
        ran.current = true;
        if (!token) {
            setStatus('error');
            return;
        }
        (async () => {
            const res = await CallApi({
                url: getVerifyEmailUrl(),
                method: 'POST',
                payload: constructVerifyEmailPayload(token),
                token: false,
            });
            setStatus(res.success ? 'success' : 'error');
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="container mt-5 text-center" style={{ maxWidth: 480 }}>
            {status === 'verifying' && <p className="text-muted">Verifying your email…</p>}
            {status === 'success' && (
                <div className="alert alert-success">
                    ✅ Your email is verified. Thanks!
                    <div className="mt-3"><Link to="/" className="btn btn-primary btn-sm">Go to home</Link></div>
                </div>
            )}
            {status === 'error' && (
                <div className="alert alert-danger">
                    This verification link is invalid or expired.
                    <div className="mt-2 small">Log in and use “Resend verification” to get a fresh link.</div>
                    <div className="mt-3"><Link to="/login">Back to login</Link></div>
                </div>
            )}
        </div>
    );
}
